<div class="user-home">
  <div class="user-home__content">
    <div class="user-home__header">
      <div>
        <h1 class="page-title">Users</h1>
        <p class="page-subtitle">Search, invite, and manage access levels.</p>
      </div>
    </div>

    <app-table
      [data]="userState.data()"
      [columns]="usersColumns"
      [config]="usersConfig"
      [pagination]="usersPagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>
</div>
